import React from 'react';
import './Stepper.scss';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { Step } from './Stepper';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

export type CovidRegistrationStepperProps = ReturnType<
  typeof mapStateToProps
> & {
  step: number;
};
const CovidRegistrationStepper: React.FC<CovidRegistrationStepperProps> = ({
  step,
  isLoggedIn
}) => {
  return (
    <div className="stepper">
      <div className="md-stepper-horizontal orange">
        <>
          <Step currentStep={step} stepIndex={0} title="Pour qui ?" />
          <Step currentStep={step} stepIndex={1} title="Compte rendu" />
        </>
        {isLoggedIn ? null : (
          <Step currentStep={step} stepIndex={2} title="Inscription" />
        )}
      </div>
    </div>
  );
};

export default connect(mapStateToProps, null)(CovidRegistrationStepper);
